import { IPhanPhongHocActionTypes } from "../../action-types/tkb/IPhanPhongActions";
import { eReducerStatusBase } from "../../reducer-model/eReducerStatusBase";
import { eXepTKBStatus, IPhanPhongHocReducer } from "../../reducer-model/tkb/IPhanPhongHocReducer";
const iniState: IPhanPhongHocReducer = {
    status: eReducerStatusBase.is_not_initialization,
    suKiens: [],
    filter: {
        hoc_ky: 0,
        id_chuyen_nganh: 0,
        id_he: 0,
        khoa_hoc: 0,
        ky_dang_ky: 0,
        nam_hoc: "",
        stu_nhomlop_id: 0,
        id_nganh: 0,
        pl_giaidoan_id: 0,
        id_bm: 0,
        id_mon: 0,
        plan_giaidoan_idx: 0
    },
    monHocs: [],
    nhomLops: [],
    phongHocSelectedId: 0
}
export const phanPhongHocReducer = (state: IPhanPhongHocReducer = iniState, action: IPhanPhongHocActionTypes): IPhanPhongHocReducer => {
    switch (action.type) {
        case "PHAN_PHONG_HOC_LOAD_SU_KIEN_START":
            return {
                ...state,
                status: eReducerStatusBase.is_loading
            }
        case "PHAN_PHONG_HOC_LOAD_SU_KIEN_SUCCESS":
            return {
                ...state,
                suKiens: action.payload,
                status: eReducerStatusBase.is_completed
            }
        case "PHAN_PHONG_HOC_LOAD_SU_KIEN_ERRR":
            return {
                ...state,
                status: eReducerStatusBase.is_completed
            }
        case "PHAN_PHONG_HOC_CHANGE_FILTER":
            return {
                ...state,
                filter: action.payload
            }
        case "PHAN_PHONG_HOC_LOAD_ALL_START":
            return {
                ...state,
                status: eXepTKBStatus.is_loading_kh,
            }
        case "PHAN_PHONG_HOC_LOAD_ALL_SUCCESS":
            return {
                ...state,
                status: eXepTKBStatus.is_completed_kh,
                // keHoachMons: action.payload,
                monHocs: action.payload.monHocs,
                nhomLops: action.payload.nhomLops,
                suKiens: action.payload.suKiens
            }
        case "PHAN_PHONG_HOC_LOAD_ALL_ERRR":
        return {
                ...state,
                status: eXepTKBStatus.is_completed_kh
            }

        case "PHAN_PHONG_HOC_UPDATE_GV_PH_SUKIEN_SUCCESS":
            const suKiensNewGVPH = [...state.suKiens];
            action.payload.forEach(sk => {
                const idx = suKiensNewGVPH.findIndex(x => x.id === sk.id);
                if (idx >= 0) {
                    suKiensNewGVPH[idx] = {
                        ...suKiensNewGVPH[idx],
                        ...sk
                    }
                }
            })
            return {
                ...state,
                status: eReducerStatusBase.is_completed,
                suKiens: suKiensNewGVPH
            }
        case "PHAN_PHONG_HOC_UPDATE_GV_PH_SUKIEN_ERRR":
            return {
                ...state,
                status: eReducerStatusBase.is_completed
            }
        case "PHAN_PHONG_HOC_UPDATE_GV_PH_SUKIEN_START":
            return {
                ...state,
                status: eReducerStatusBase.is_saving
            }
        case "PHAN_PHONG_HOC_CHANGE_SELECTED_PHONGHOC_ID":
            return {
                ...state,
                phongHocSelectedId: action.payload
            }
        default:
            return {
                ...state
            };
    }
}